import { useGetPublicService } from "@domain/util-service/new-util-service/get-public-service.hook";
import { useParams } from "react-router-dom";

import PublicBookingFlow from "../public-booking-flow/public-booking-flow";

export function NewRegistrationWithBooking() {
  const { client: tenant = "" } = useParams<{ client: string }>();
  const { isFetchingServices, contactInfo, serviceOptions } =
    useGetPublicService();

  // Use tenant as clinic name (can be enhanced to fetch actual clinic name)
  const clinicName = tenant
    ? tenant.charAt(0).toUpperCase() + tenant.slice(1)
    : undefined;

  return (
    <PublicBookingFlow
      serviceOptions={serviceOptions}
      isFetchingServices={isFetchingServices}
      contactInfo={contactInfo}
      clinicName={clinicName}
      tenant={tenant}
    />
  );
}

export default NewRegistrationWithBooking;
